import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const TESTIMONIALS = [
  {
    quote:
      'We replaced three tools and still got better integrity signals. Our hiring managers finally trust the pipeline.',
    name: 'Sarah Chen',
    role: 'VP Talent Acquisition',
    company: 'Series C Fintech',
    initials: 'SC',
  },
  {
    quote:
      'Autonomous interviews run overnight. Candidates get a fair process; our team gets time back for decisions that matter.',
    name: 'James Okonkwo',
    role: 'Head of Engineering Hiring',
    company: 'Global SaaS',
    initials: 'JO',
  },
  {
    quote:
      'OS-level proctoring caught what video calls never would. That alone paid for the platform in one bad-hire avoided.',
    name: 'Ana Rodriguez',
    role: 'Director, People Ops',
    company: 'Enterprise Tech',
    initials: 'AR',
  },
];

export default function LoginShowcasePanel() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const id = setInterval(() => {
      setIndex((i) => (i + 1) % TESTIMONIALS.length);
    }, 7000);
    return () => clearInterval(id);
  }, []);

  const active = TESTIMONIALS[index];

  return (
    <aside
      className="login-showcase relative hidden lg:flex lg:w-[46%] xl:w-[48%] shrink-0 flex-col justify-between overflow-hidden px-10 xl:px-14 pb-10 xl:pb-12 login-showcase__inner"
      aria-label="Customer stories"
    >
      <div className="login-showcase__mesh" aria-hidden="true" />
      <div className="login-showcase__grid" aria-hidden="true" />

      <div className="relative z-10 flex-1 flex flex-col justify-center max-w-md py-6">
        <AnimatePresence mode="wait">
          <motion.div
            key={active.name}
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
          >
            <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-indigo-300/80 mb-6">
              What teams say
            </p>
            <blockquote className="text-[1.65rem] xl:text-[1.85rem] font-medium text-white leading-[1.35] tracking-tight mb-8">
              &ldquo;{active.quote}&rdquo;
            </blockquote>
            <div className="flex items-center gap-3">
              <div className="h-10 w-10 rounded-full bg-white/10 border border-white/15 flex items-center justify-center text-xs font-semibold text-white/90 shrink-0">
                {active.initials}
              </div>
              <div>
                <p className="text-sm font-medium text-white">{active.name}</p>
                <p className="text-xs text-white/50">
                  {active.role} · {active.company}
                </p>
              </div>
            </div>
          </motion.div>
        </AnimatePresence>

        <div className="flex gap-2 mt-10" role="tablist" aria-label="Testimonials">
          {TESTIMONIALS.map((t, i) => (
            <button
              key={t.name}
              type="button"
              role="tab"
              aria-selected={i === index}
              aria-label={`Testimonial from ${t.name}`}
              onClick={() => setIndex(i)}
              className={`h-1 rounded-full border-0 cursor-pointer transition-all duration-300 p-0 ${
                i === index ? 'w-5 bg-white/85' : 'w-1 bg-white/25 hover:bg-white/45'
              }`}
            />
          ))}
        </div>
      </div>

      <div className="relative z-10 flex items-center gap-6 text-[11px] text-white/45 pt-4 border-t border-white/10">
        <span className="flex items-center gap-1.5">
          <span className="text-emerald-400/80 shrink-0" aria-hidden="true">✓</span>
          Enterprise-grade security
        </span>
        <span className="hidden xl:inline">·</span>
        <span className="hidden xl:inline">Integrity signals for human review</span>
        <span className="hidden xl:inline">·</span>
        <span className="hidden xl:inline">68% faster cycles</span>
      </div>
    </aside>
  );
}
